var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('el-radio-group',{on:{"change":_vm.goPage},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-radio-button',{attrs:{"label":"list"}},[_vm._v("列表")]),_c('el-radio-button',{attrs:{"label":"map"}},[_vm._v("地图")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }